'use client';

import { type JSX, useState } from 'react';

import { topNavActionPlacement } from '../shared/topNavActionPlacement';
import type { MobileNavConfig } from '../types';
import MobileNavOverlay from './MobileNavOverlay';

interface MobileNavProps {
    config: MobileNavConfig;
    darkHeader?: boolean;
}

export default function MobileNav({ config, darkHeader = false }: MobileNavProps): JSX.Element {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    return (
        <>
            {/* Nav bar actions — visible on mobile only */}
            <div className="flex items-center gap-6 topnav-sm:hidden">
                {config.navBarCta && (
                    <a
                        href={config.navBarCta.href}
                        data-cta={topNavActionPlacement(config.navBarCta.href)}
                        className="flex items-center justify-center rounded-[10px] bg-yellow-400 px-6 py-1.5 text-sm font-semibold text-gray-900 hover:bg-yellow-500"
                    >
                        {config.navBarCta.label}
                    </a>
                )}
                <button
                    type="button"
                    onClick={(): void => setIsMenuOpen(true)}
                    aria-label="Open menu"
                    aria-expanded={isMenuOpen}
                    aria-haspopup="true"
                >
                    <svg width="24" height="24" viewBox="0 0 16 16" fill="none">
                        <path
                            d="M2 4H14M2 8H14M2 12H14"
                            stroke={darkHeader ? '#FFFFFF' : '#1F2830'}
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </button>
            </div>

            {/* Full-screen overlay */}
            <MobileNavOverlay
                isOpen={isMenuOpen}
                onClose={(): void => setIsMenuOpen(false)}
                navItems={config.navItems}
                bottomActions={config.overlayActions}
            />
        </>
    );
}
